export default __webpack_public_path__ + "static/media/star.c8cfa0cb.svg";